import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { Mandate } from '../../Models/Models/Mandate/Mandate';

declare var IS_RUNNING_IN_APP_POOL;

export class MandateNameFuzzySearchClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(partialName: string): Promise<Array<Mandate>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Mandate/MandateNameFuzzySearch/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { partialName: partialName }

    return AjaxWrapper.get<Array<Mandate>, any>(url, data);
  }
}

